import React, { Component } from "react";
import { Row, Col, Form, Modal, Button, Spinner } from "react-bootstrap";

class ModalAdd extends Component {
  state = {};

  onChangeAudioFile = e => {
    console.log(e.target.files[0]);
  };

  render() {
    return (
      <React.Fragment>
        <Modal
          onEntered={this.handleOpen}
          show={this.props.showAddModal}
          onHide={this.props.handleClose}
          dialogClassName="editModal"
        >
          <Form onSubmit={this.props.onFormSubmitAddSound}>
            <Modal.Header closeButton>
              <Form.Control
                required
                type="text"
                name="soundName"
                className="input-text-sound-name"
                placeholder="Give a name"
              />
            </Modal.Header>
            <Modal.Body>
              <div style={{ fontSize: "13px", fontWeight: "500" }}>
                <Row>
                  <Col md={12}>
                    <Row>
                      <Col md={6}>
                        <Form.Group controlId="formAudioFile">
                          <Form.Label>Choose Audio File</Form.Label>
                          <Form.Control
                            onChange={this.props.onChangeAudioFile}
                            required
                            type="file"
                            name="audio"
                            placeholder="Choose Audio File"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </Modal.Body>

            <Modal.Footer>
              {this.props.isAddingNewSound === true ? (
                <Spinner animation="border" role="status"></Spinner>
              ) : (
                <Button variant="primary" type="submit">
                  Add
                </Button>
              )}
            </Modal.Footer>
          </Form>
        </Modal>
      </React.Fragment>
    );
  }
}

export default ModalAdd;
